import React from 'react';

const Setting = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 11.8125C10.5533 11.8125 11.8125 10.5533 11.8125 9C11.8125 7.4467 10.5533 6.1875 9 6.1875C7.4467 6.1875 6.1875 7.4467 6.1875 9C6.1875 10.5533 7.4467 11.8125 9 11.8125Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.91312 12.522C2.60232 11.9867 2.36422 11.4124 2.20508 10.8141L3.38492 9.33758C3.37156 9.11184 3.37156 8.88551 3.38492 8.65977L2.20578 7.1832C2.36465 6.5849 2.60227 6.01034 2.91242 5.47461L4.79047 5.26367C4.94044 5.09471 5.10033 4.93481 5.2693 4.78484L5.48023 2.9075C6.0152 2.59882 6.58881 2.36262 7.18602 2.20508L8.66258 3.38492C8.88832 3.37156 9.11465 3.37156 9.34039 3.38492L10.817 2.20578C11.4153 2.36465 11.9898 2.60227 12.5255 2.91242L12.7365 4.79047C12.9054 4.94044 13.0653 5.10033 13.2153 5.2693L15.0927 5.48023C15.4035 6.01557 15.6416 6.58992 15.8007 7.18813L14.6209 8.66469C14.6342 8.89043 14.6342 9.11676 14.6209 9.3425L15.8 10.8191C15.6422 11.4172 15.4058 11.9917 15.0969 12.5277L13.2188 12.7386C13.0689 12.9076 12.909 13.0675 12.74 13.2174L12.5291 15.0948C11.9937 15.4056 11.4194 15.6437 10.8212 15.8028L9.34461 14.623C9.11887 14.6363 8.89254 14.6363 8.6668 14.623L7.19023 15.8021C6.5921 15.6444 6.01756 15.4079 5.48164 15.099L5.2707 13.2209C5.10174 13.071 4.94185 12.9111 4.79188 12.7421L2.91312 12.522Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Setting;
